import { UserRole } from '@shared/types/user';
import { DIVIDER, MenuItem } from './menu-item.type';

export const JACKPOT_MENU_ITEMS: MenuItem[] = [
  {
    name: 'header.client',
    url: '/client',
    icon: 'Gear',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.jackpotMetrics',
    url: '/jackpot-metrics',
    icon: 'Metrics',
    permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
  },
  {
    name: 'header.jackpotTracker',
    url: '/tracker',
    icon: 'Track',
    permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
  },
  DIVIDER,
  {
    name: 'header.jackpotGames',
    url: '/jackpot-levels',
    icon: 'Games',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotGroups',
    url: '/jackpot-groups',
    icon: 'Groups',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.users',
    url: '/jackpot-users',
    icon: 'Users',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotParticipation',
    url: '/jackpot-participation',
    icon: 'Arrows-up',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotWins',
    url: '/jackpot-wins',
    icon: 'Trophy',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotTransactionTracking',
    url: '/jackpot-transaction-tracking',
    icon: 'Transaction',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.jackpotPayouts',
    url: '/jackpot-payouts',
    icon: 'Gift',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotWithdraws',
    url: '/jackpot-withdraws',
    icon: 'Diamond',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.CustomerSupport,
    ],
  },
  {
    name: 'header.jackpotMonthlyReport',
    url: '/jackpot-monthly-report',
    icon: 'Data',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.jackpotAggregates',
    url: '/jackpot-aggregates',
    icon: 'Arrow-up',
    permission: [UserRole.Admin, UserRole.ClientAdmin, UserRole.Manager],
  },
  {
    name: 'header.currencies',
    url: '/currencies',
    icon: 'Currency',
    permission: [
      UserRole.Admin,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.Manager,
    ],
  },
  DIVIDER,
  {
    name: 'header.gameTags',
    url: '/jackpot-tags',
    icon: 'Tag',
    permission: [
      UserRole.Admin,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.Manager,
      UserRole.CustomerSupport,
    ],
  },
  DIVIDER,
  {
    name: 'header.actions',
    url: '/actions',
    icon: 'List',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.reporting',
    url: '/reporting',
    icon: 'Mail',
    permission: [
      UserRole.Admin,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.Manager,
    ],
  },
  {
    name: 'header.labels',
    url: '/labels',
    icon: 'Language',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.assets',
    url: '/assets',
    icon: 'Upload',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.theme',
    url: '/jackpot-theme',
    icon: 'Droplet',
    permission: [UserRole.Admin, UserRole.ClientAdmin],
  },
  {
    name: 'header.tokenValidation',
    url: '/token-validation',
    icon: 'Security',
    permission: [
      UserRole.Admin,
      UserRole.Manager,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
    ],
  },
  {
    name: 'header.tasks',
    url: '/tasks',
    icon: 'Tasks',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.preview',
    url: '/preview',
    icon: 'Eye',
    permission: [UserRole.Admin],
  },
  {
    name: 'header.simulation',
    url: '/simulation',
    icon: 'Simulation',
    permission: [
      UserRole.Admin,
      UserRole.ClientAdmin,
      UserRole.Supervisor,
      UserRole.Manager,
    ],
  },
  DIVIDER,
  {
    name: 'header.auditLogs',
    url: '/audit-logs',
    icon: 'logs',
    permission: [UserRole.Admin],
  },
];
